import { __awaiter } from "tslib";
import { jsx as _jsx } from "preact/jsx-runtime";
import { useEffect, useState } from 'react';
import { CollapsibleBanner } from 'pathfinder/modules/shared/CollapsibleBanner/CollapsibleBanner';
import { getLastAction, saveAction, saveImpressionAction } from 'pathfinder/utils/actionsHelper';
import { getCookieByName } from 'utils/getCookieByName';
import { setActiveNotificationCookie } from 'pathfinder/modules/MarketingNotifications/helpers/activeNotification';
import { useNotificationsTracking } from 'pathfinder/modules/MarketingNotifications/hooks/useNotificationsTracking';
import useSiteNoticeListener from 'pathfinder/modules/MarketingNotifications/hooks/useSiteNoticeListener';
import { BEACON_COOKIE, BEACON_URL_PARAM, BEACON_URL_PARAM_INITIAL_VALUE, } from 'pathfinder/modules/MarketingNotifications/consts';
import { setClosedNotificationsData, cleanUpClosedNotificationStorage, getClosedNotificationsData, } from './helpers/storage';
import { getIsNotificationClosed } from 'pathfinder/modules/MarketingNotifications/helpers/getIsNotificationClosed';
export const MarketingNotificationModule = ({ notification, isMobile, moduleName, hasAnonMobileNotificationsEvent, log, }) => {
    const [isImpressionSaved, setIsImpressionSaved] = useState(false);
    const [isBannerExpanded, setIsBannerExpanded] = useState(false);
    const [trackNotificationImpression, trackNotificationEvent] = useNotificationsTracking(moduleName, notification);
    const { body, cta, url, id, type } = notification;
    const isSiteNotice = useSiteNoticeListener(isMobile);
    const notificationsInStorage = getClosedNotificationsData();
    const [isNotificationClosed, setIsNotificationClosed] = useState(getIsNotificationClosed(id, notificationsInStorage));
    const beaconCookieValue = getCookieByName(BEACON_COOKIE);
    const onArrowClick = (isExpanded) => {
        const action = isExpanded ? 'close' : 'open';
        saveAction(moduleName, window.SilverSurferSDK.ACTION.CLICK, { userAction: action, notificationId: id });
        trackNotificationEvent(`${action}-click`);
        setIsBannerExpanded(!isBannerExpanded);
    };
    const onCTAClick = () => {
        // prevent showing any notification for next 24 hrs
        setActiveNotificationCookie(-1);
        trackNotificationEvent('CTA-click');
    };
    const updateUrlBeaconParam = (url, paramValue) => {
        const urlObject = new URL(url);
        if (urlObject.searchParams.get(BEACON_URL_PARAM) === BEACON_URL_PARAM_INITIAL_VALUE) {
            urlObject.searchParams.set(BEACON_URL_PARAM, paramValue);
            return urlObject.toString();
        }
        return url;
    };
    useEffect(() => {
        if (isNotificationClosed) {
            // filter out the expired notifications
            cleanUpClosedNotificationStorage(notificationsInStorage);
            log.debug(`Notification with id ${id} is in the storage and it won't be shown`);
        }
    }, [isNotificationClosed]);
    // persist closed state and unmount
    const onCloseClick = () => {
        // persist closed state to localstorage ( do not show this certain notification for next 30 days )
        setClosedNotificationsData(id);
        setIsNotificationClosed(true);
        trackNotificationEvent('dismiss-X-click');
        // prevent showing any notification for next 24 hrs
        setActiveNotificationCookie(-1);
    };
    const checkIfExpanded = () => __awaiter(void 0, void 0, void 0, function* () {
        const lastAction = yield getLastAction(moduleName, window.SilverSurferSDK.ACTION.CLICK);
        if (lastAction) {
            const payload = lastAction.payload;
            if (payload.notificationId === id) {
                const isExpanded = payload.userAction === 'open';
                setIsBannerExpanded(isExpanded);
                return;
            }
        }
        setIsBannerExpanded(true);
    });
    useEffect(() => {
        if (isBannerExpanded) {
            trackNotificationImpression();
        }
    }, [isBannerExpanded]);
    useEffect(() => {
        if (!isImpressionSaved && moduleName) {
            // eslint-disable-next-line regex/invalid
            setActiveNotificationCookie(id);
            saveImpressionAction(moduleName, { id, type });
            setIsImpressionSaved(true);
        }
        checkIfExpanded();
    }, []);
    const updatedUrl = updateUrlBeaconParam(url, beaconCookieValue);
    return (!isSiteNotice &&
        !isNotificationClosed && (_jsx(CollapsibleBanner, { body: body, cta: cta, url: updatedUrl, type: type, className: 'marketing-notification__container', isMobile: isMobile, isExpanded: isBannerExpanded, onCTAClick: onCTAClick, onArrowClick: onArrowClick, onCloseClick: onCloseClick, hasAnonMobileNotificationsEvent: hasAnonMobileNotificationsEvent }, void 0)));
};
